import { Component, OnInit, ViewChild } from '@angular/core';
import { BookingOrderService } from '../../services/booking-order.service';
import { BookingStepService } from '../../services/booking-step.service';

@Component({
  selector: 'app-booking-event-slot-product',
  templateUrl: './booking-event-slot-product.component.html',
  styleUrls: ['./booking-event-slot-product.component.css']
})
export class BookingEventSlotProductComponent implements OnInit {

  @ViewChild('ticketConfigurator', {static: true}) ticketConfigurator;

  constructor(
    protected bookingStepService: BookingStepService,
    private bookingOrderService: BookingOrderService,
  ) { }

  ngOnInit(): void {
  }

  onBackwardClick(): void {
    this.bookingStepService.back();
  }

  onForwardClick(): void {
    this.bookingStepService.forward();
  }

  get forwardError(): string {
    if (this.ticketConfigurator.selectedProductTimeSpan && !this.ticketConfigurator.selectedProductTimeSpan.isCapacityAvailable) {
      return this.ticketConfigurator.selectedProductTimeSpan.footer;
    }

    return this.bookingOrderService.singleCache.invalidReason;
  }
}
